export default __webpack_public_path__ + "static/media/nav-qa-fill.b34038fb.svg";